import { useAuth } from '@/auth/useAuth';
import { LoginPane } from '@/panes/LoginPane';
import { HomePane } from '@/panes/HomePane';
import { AppShell } from '@/components/AppShell';

export default function App() {
  const { isAuthenticated, isReady } = useAuth();

  if (!isReady) {
    return (
      <AppShell>
        <div className="flex h-full items-center justify-center text-sm text-lex-slate-500">
          Cargando…
        </div>
      </AppShell>
    );
  }

  return <AppShell>{isAuthenticated ? <HomePane /> : <LoginPane />}</AppShell>;
}
